import { __decorate } from "tslib";
import { Pipe } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
let SafeUrlPipe = class SafeUrlPipe {
    domSanitizer;
    constructor(domSanitizer) {
        this.domSanitizer = domSanitizer;
    }
    transform(url) {
        return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
    }
    static ctorParameters = () => [
        { type: DomSanitizer }
    ];
};
SafeUrlPipe = __decorate([
    Pipe({
        name: "safeUrl"
    })
], SafeUrlPipe);
export { SafeUrlPipe };
